export const AuthenticateUser = (per: any) => {
  const data: any = localStorage?.getItem('permission')
  const permission = JSON?.parse(data)

  if (permission?.includes(per)) {
    return true
  } else {
    return false
  }
}

export const StatusColor: any = {
  unverified: 'warning',
  verified: 'success',
  inactive: 'danger',
  suspended: 'warning',
  active: 'success',
  unfinished: 'warning',
}
